<style lang="stylus">
    .dialog-container-component
        position absolute
        left 50%
        top 50%
        background-color var(--bg-color-dialog-container)
        outline none
        z-index 101
        border-radius 8px
        box-shadow $modal-shadow
        border: 1px solid var(--border-color-dialog-container);
        user-select none
        max-height 90%
        &.forcecenter
            left 50% !important
            top 50% !important
            transform translate(-50%, -50%) !important
        .dialog-title
            cursor: move;
            font-weight: 600
            z-index 30
            position relative
            height 40px
            width 100%
            padding-right 12px
            background-color var(--bg-color-dialog-container)
            color var(--text-color-primary)
            font-size $modal-title-textsize
            border-top-left-radius 5px
            border-top-right-radius 5px
            .item-icon
                position absolute
                width 20px
                height 20px
                top 11px
            .title-text-wiIcon
                margin-left 22px
            .title-text
                cursor: initial;
                color var(--text-color-primary)
                position absolute
                left 24px
                font-size 14px
                line-height 42px
                font-weight 700
                margin: 0
            .title-close
                color : var(--svg-color-gray-42);
                position absolute
                top 7px
                right 7px
                width 24px
                height 24px
                cursor pointer
                border-radius 6px
                &:hover
                    background var(--bg-color-dialog-close-hover)
                >svg
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%, -50%)
                    width 16px
                    height 16px
        .dialog-slot
            padding:14px 24px 24px
            max-height 100%
            overflow-y overlay
            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background: var(--bg-color-dialog-scroll-bar);
            }
            &::-webkit-scrollbar-track {
                border-radius: 10px;
            }
        .only-btn-ok
            right 30px !important
</style>

<template>
    <div
        tabindex="-1"
        ref="dialogRootEle"
        @blur="dialogBlur"
        class="dialog-container-component"
        :class="{ forcecenter: forceCenter }"
        :style="{ top: top + 'px', left: left + 'px', zIndex: zIndex !== '' ? zIndex : '' }"
    >
        <div class="dialog-title" v-if="!hiddenTitle" @mousedown="move($event)">
            <template v-if="$slots.title">
                <slot name="title"></slot>
            </template>
            <template v-else>
                <iconSymbol v-if="!isMath && icon" class="item-icon" :name="icon"></iconSymbol>
                <!-- <iconSymbol v-if='isMath && icon' class="item-icon" :name="icon"></iconSymbol> -->
                <p class="title-text" :class="{ 'title-text-wiIcon': !isMath && icon }">{{ topTitle }}</p>
            </template>
            <div class="title-close" v-if="!onlyOK" @click="cancel('close')" @mousedown.stop>
                <iconSymbol name="Del" />
            </div>
        </div>
        <div :class="{ 'dialog-slot': media }">
            <slot></slot>
            <div
                v-if="showFooter"
                class="dialog-btnbox-normal"
                :class="{ 'vip-dialog-btnbox-normal': showVipIcon }"
                :style="{ direction: !internal ? 'ltr' : 'rtl' }"
            >
                <div class="" v-if="!onlyOK" @click="cancel('cancel')">{{ $t("cancel") }}</div>
                <div
                    class="dialog-btn-ok"
                    :class="{
                        'only-btn-ok': onlyOK,
                        'dialog-disable': disablConfirm,
                        'hover-btn': hoverShowVipIcon,
                    }"
                    @click="ok"
                >
                    <VipIcon v-if="showVipIcon || hoverShowVipIcon" />
                    <span>{{ $t("confirm") }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    declare var EDView: any;
    import { Watch, Component, Prop, Vue } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件

    @Component({
        components: {},
    })
    export default class Base extends Vue {
        // @Prop({ default: true }) readonly ctrlByStore: boolean // 是否由 store里的变量控制显隐
        @Prop({ default: "" }) readonly title: string; //modal的标题
        @Prop({ default: "" }) readonly icon: string; // modal的logo
        @Prop({ default: "" }) readonly type: string; // Dialog的type 字符串
        @Prop({ default: false }) readonly extra: string; // 是否是额外的dialog
        @Prop({ default: false }) readonly mask: boolean; //是否显示遮罩层
        @Prop({ default: true }) readonly media: boolean; //是否增加高度滚动条
        @Prop({ default: 580 }) readonly width: number; //整体宽度
        @Prop({ default: false }) readonly autoFocus: boolean; //是否要加自动focus.
        @Prop({ default: false }) readonly isMath: boolean; //是否是Math
        @Prop({ default: false }) readonly showFooter: boolean; //是否显示底部的 确定&取消，显示则要加ok和close.不显示则要自己slot里控制
        @Prop({ default: "" }) readonly contentWidth: number; // 内容宽度
        @Prop({ default: "" }) readonly contentHeight: number; // 内容高度
        @Prop({ default: "" }) readonly zIndex: number; // 窗口z-index
        @Prop({ default: false }) readonly onlyOK: boolean; // 只显示确认
        @Prop({ default: false }) readonly disablConfirm: boolean; // 确认按钮禁止点击
        @Prop({ default: false }) readonly showVipIcon: boolean; // 是否显示vip标识
        @Prop({ default: false }) readonly hoverShowVipIcon: boolean; //hover显示vip标识
        @Prop({ default: false }) readonly hiddenTitle: boolean; // 去除头部
        @Prop({ default: false }) readonly forceCenter: boolean; // 窗口固定居中
        x = 0;
        y = 0;
        top = 0;
        left = 0;
        //生命周期
        get topTitle() {
            return this.title || (this.type && this.$t(this.type)) || "";
        }
        mounted() {
            this.$emit("actived");
            if (this.autoFocus) {
                (<any>this.$refs.dialogRootEle).focus();
            }
            if (this.mask) {
                this.$store.commit("setDialogState", {
                    type: "showDialogMask",
                    data: true,
                });
            }
            // 如果同时有两个弹窗 用document.querySelector获取的都是第一个元素dom
            if (!this.forceCenter) {
                let dom = this.$refs.dialogRootEle as HTMLElement;
                this.left = (document.documentElement.clientWidth - dom.clientWidth) / 2;
                this.top = (document.documentElement.clientHeight - dom.clientHeight) / 2;
                if (this.contentWidth && this.contentHeight) {
                    this.left = (document.documentElement.clientWidth - this.contentWidth) / 2;
                    this.top = (document.documentElement.clientHeight - this.contentHeight) / 2;
                }
            }
        }
        // 一般在父组件调用
        resetPosition() {
            if (this.forceCenter) return;
            this.left = (document.documentElement.clientWidth - document.querySelector(".dialog-container-component").clientWidth) / 2;
            this.top = (document.documentElement.clientHeight - document.querySelector(".dialog-container-component").clientHeight) / 2;
            if (this.contentWidth && this.contentHeight) {
                this.left = (document.documentElement.clientWidth - this.contentWidth) / 2;
                this.top = (document.documentElement.clientHeight - this.contentHeight) / 2;
            }
        }
        forceSetPosition(x, y) {
            if (this.forceCenter) return;
            this.left = x;
            this.top = y;
        }
        dialogBlur() {
            if (this.autoFocus) {
                this.cancel();
            }
        }
        keyboardEvent(e) {
            let ctrlKey = EDView.osInfo.platform === "Mac" ? e.metaKey : e.ctrlKey;
            if (ctrlKey && e.keyCode == 83) {
                // 屏蔽ctrl+s
                e.preventDefault();
            }
            if (e.keyCode == 27) {
                // esc
                this.cancel();
            }
        }
        created() {
            document.addEventListener("keydown", this.keyboardEvent);
        }

        moveOutside(x, y) {
            if (this.forceCenter) return;
            this.left += x;
            this.top += y;

            const dom = <any>this.$refs.dialogRootEle;
            const maxLeft = window.innerWidth - dom.offsetWidth;
            const maxTop = window.innerHeight - dom.offsetHeight;
            if (this.left > maxLeft) {
                this.left = maxLeft;
            } else if (this.left < 0) {
                this.left = 0;
            }
            if (this.top > maxTop) {
                this.top = maxTop;
            } else if (this.top < 0) {
                this.top = 0;
            }
        }

        move(e) {
            if (this.forceCenter) return;
            this.x = e.clientX;
            this.y = e.clientY;
            let left = this.left;
            let top = this.top;
            const dom = <any>this.$refs.dialogRootEle;
            const maxLeft = window.innerWidth - dom.offsetWidth;
            const maxTop = window.innerHeight - dom.offsetHeight;
            document.onmousemove = (e) => {
                this.left = left + e.clientX - this.x;
                this.top = top + e.clientY - this.y;
                if (this.left > maxLeft) {
                    this.left = maxLeft;
                } else if (this.left < 0) {
                    this.left = 0;
                }
                if (this.top > maxTop) {
                    this.top = maxTop;
                } else if (this.top < 0) {
                    this.top = 0;
                }
            };
            document.onmouseup = () => {
                document.onmousemove = null;
            };
        }
        ok() {
            this.$emit("ok");
        }
        cancel(type?) {
            this.$emit("close", type); //额外关闭运行函数
            if (!this.extra) {
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: false,
                });
            }
        }
        beforeDestroy() {
            document.removeEventListener("keydown", this.keyboardEvent);
            if (this.mask && !this.extra) {
                this.$store.commit("setDialogState", {
                    type: "showDialogMask",
                    data: false,
                });
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "tip": "提示",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "tip": "Tip",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "tip": "Indice",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "tip": "Hinweis"
  },
  "jp": {
    "confirm": "OK",
    "cancel": "キャンセル",
    "tip": "ご注意"
  },
  "es": {
    "tip": "Consejo",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "pt": {
    "tip": "Ponta",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "tip": "Suggerimento",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "tip": "提示",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "tip": "팁",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
